import { useState } from "react";

export const useOnboardingAgentFeedbackToolbar = () => {
    const [likeActive, setLikeActive] = useState(false);
    const [dislikeActive, setDislikeActive] = useState(false);

    const handleClearLike = (): void => {
        setLikeActive(false);
    };

    const handleClearDislike = (): void => {
        setDislikeActive(false);
    };

    return {
        likeActive,
        dislikeActive,
        setLikeActive,
        setDislikeActive,
        handleClearLike,
        handleClearDislike,
    };
};
